import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"check\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.067 31.933l2.28-2.28 15.967 15.966-2.28 2.28L.066 31.934z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M45.686 13.686l2.28 2.28L16.034 47.9l-2.28-2.281 31.933-31.933z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol